<template>
    <div class="main">
        <topback title="Sell history" path="back"></topback>
        <md-tab-bar
            v-model="main_current"
            :items="main_items"
            class="main-tab"
        />
        <div v-if="main_current === 0">
            <md-tab-bar v-model="entrust_current" :items="items" @change="onTabChange"></md-tab-bar>
            <md-swiper ref="swiper" :autoplay="0" :is-prevent="false" :is-loop="false" :has-dots="false"
                @before-change="onSwiperChange">
                <md-swiper-item>
                    <sellhitorylist status="dispatched" v-if="status === 'dispatched'"></sellhitorylist>
                </md-swiper-item>
                <md-swiper-item>
                    <sellhitorylist status="success" v-if="status === 'success'"></sellhitorylist>
                </md-swiper-item>
                <md-swiper-item>
                    <sellhitorylist status="timeout" v-if="status === 'timeout'"></sellhitorylist>
                </md-swiper-item>
                <md-swiper-item>
                    <sellhitorylist status="offline" v-if="status === 'offline'"></sellhitorylist>
                </md-swiper-item>
            </md-swiper>
        </div>
        <div v-else>
            <span>No order yet</span>
        </div>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import sellhitorylist from '@/views/my/sellhitorylist'
import { getcwexchangerate, availablect, startsell, cwworkerstate, stopsell } from '@/request/api'

export default {
    name: 'sell',
    components: {
        [topback.name]: topback,
        iconimg,
        sellhitorylist
    },
    data() {
        return {
            main_current: 0,
            main_items: [
                {name: 0, label: "Entrust"},
                {name: 1, label: "Block Trade"},
            ],
            entrust_current: 0,
            items: [
                {name: 0, label: 'Paying', status: 'dispatched'},
                { name: 1, label: 'Success', status: 'success' },
                { name: 2, label: 'Timeout', status: 'timeout' },
                { name: 3, label: 'Offline', status: 'offline' }
            ],
            status: "dispatched",
            isPopupShow: {},
        }
    },
    watch: {

    },
    created() {
    },
    methods: {
        onSwiperChange(from, to) {
            this.entrust_current = to
            let foundItem = this.items.find(item => item.name === to);
            this.status = foundItem.status;
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0;
		},
        onTabChange(item, index) {
			this.$refs.swiper.goto(index);
		},
        showPopUp(type) {
            this.$set(this.isPopupShow, type, true);
        },
        hidePopUp(type) {
            this.$set(this.isPopupShow, type, false);
        },
    }

}
</script>


<style scoped>
.main-tab {
    margin-top: 1rem;
}

.deposit-history .md-swiper {
	background: #FFF;
}

.deposit-history .md-swiper .md-swiper-item {
	padding: 20px;
	box-sizing: border-box;
	font-size: 24px;
	line-height: 1.5;
	color: #666;
}

</style>


// WEBPACK FOOTER //
// src/views/my/sellhistory.vue